import { Button, FormControlLabel, FormGroup, Switch } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Modal } from "react-bootstrap";
import CloseIcon from '@mui/icons-material/Close';
import { ConnectionState, User, useChat } from '../@chatscope/use-chat/src';
import { getUserData } from '../utils/peopleSearch';
import { useMsal } from '@azure/msal-react';
import './Ping.css'



export function Menu() {

  const {
    getCurrentUser
  } = useChat();

  const { saveSettingsFile, loadSettingsFile, connectionStatus } = useChat();
  const [showModal, setShowModal] = useState(false);
  const [settingsFile, setSettingsFile] = useState<any>({});
  const [notificationPermission, setNotificationPermission] = useState(false);
  const [notificationSound, setNotificationSound] = useState(false);
  const currentUser: User<any> = getCurrentUser() as User<any>;

  useEffect(() => {
    console.log(`[Menu] connectionStatus: ${connectionStatus}`); 
    loadSettingsFromStorage();
  }, [connectionStatus]);

  useEffect(() => {
    setShowModal(true);
  }, []);

  useEffect(() => {
    if (settingsFile !== null && Object.keys(settingsFile).length !== 0) {
      if (settingsFile.settings.notifications === true) {
        setNotificationPermission(true);

      }
      if (settingsFile.settings.notificationSound === true) {
        setNotificationSound(true);
      }
    }
  }, [settingsFile])

  const loadSettingsFromStorage = async () => {
    try {
      const settings = await loadSettingsFile();
      setSettingsFile(settings);
    } catch (error) {
      console.error(`[loadSettingsFromStorage] Failed to load settings from storage: ${error}`);
    }
  };

  const saveSettings = async (settings: any) => {
    try {
      const jsonSettings = JSON.stringify(settings);
      const base64EncodedString = btoa(jsonSettings);
      saveSettingsFile(`${currentUser.id} settings.json`, base64EncodedString);
    } catch (error) {
      console.error('[saveSettings] Error saving settings:', error);
    }
  }

  const closePopup = () => {
    setShowModal(false);
  };

  const handleNotifications = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    setNotificationPermission(event.target.checked);
    if (notificationPermission === true && Notification.permission === 'granted') {
      settingsFile.settings.notifications = false;
    }
    else if (notificationPermission === false && Notification.permission === 'granted') {
      settingsFile.settings.notifications = true;
    }
    else {
      if (Notification.permission === "default" || Notification.permission === "denied") {
        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            settingsFile.settings.notifications = true;
          }
        });
      }
    }
    setSettingsFile(settingsFile);
    saveSettings(settingsFile);
  }, [notificationPermission, saveSettingsFile, settingsFile]);

  const handleNotificationSound = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNotificationSound(event.target.checked);
    if (notificationSound === true) {
      settingsFile.settings.notificationSound = false;
    }
    else {
      settingsFile.settings.notificationSound = true;
    }
    setSettingsFile(settingsFile);
    saveSettings(settingsFile);
  };

  return (
    <Modal show={showModal} onHide={() => closePopup()} centered>
      <div style={{ position: 'absolute', top: '50%', left: '50%', bottom: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'white', padding: '25px', borderRadius: '8px', width: '100%', height: '300px' }}>
        <div style={{ position: 'absolute', top: 0, right: 0 }}>
          <Button onClick={closePopup}>
            <CloseIcon />
          </Button>
        </div>
        <h4>Settings</h4>
        <br></br>
        <div>
          <FormGroup style={{ alignItems: 'center', textAlign: "center" }}>
            <FormControlLabel
              value="Notifications"
              control={<Switch checked={notificationPermission} onChange={handleNotifications} color="primary" />}
              label="Allow Notifications"
              labelPlacement="start"
            />
            <br></br>
            <FormControlLabel
              value="NotificationSound"
              control={<Switch checked={notificationSound} onChange={handleNotificationSound} color="primary" />}
              label="Allow Notification Sound"
              labelPlacement="start"
            /></FormGroup>
        </div>
      </div>
    </Modal>
  );
}

export default Menu;